<template>
  <div class="userWrap  pa16">
    <a-row :gutter="12" class="mb10">
      <a-col :span="6" class="df aic">
        <span style="width:80px;" class="tar"> 部门：</span>
        <a-input
          v-model:value="params.departName"
          placeholder="请输入部门名称"
          allowClear
        ></a-input>
      </a-col>
      <a-col :span="6" class="df aic">
        <span style="width:80px;" class="tar"> 人员：</span
        ><a-input
          v-model:value="params.userName"
          placeholder="请输入用户名"
          allowClear
        ></a-input>
      </a-col>
      <a-col :span="6"></a-col>
      <a-col :span="6" class="tar">
        <a-button type="link" size="small" class="mr10" @click="batchAssign"
          >批量分配</a-button
        >
        <a-button type="primary" size="small" @click="reset">查询</a-button>
      </a-col>
    </a-row>
    <a-table
      :pagination="false"
      :row-selection="{
        onChange: setUserIds,
        selectedRowKeys: userIds
      }"
      rowKey="id"
      size="small"
      bordered
      :scroll="{
        y: 650
      }"
      :columns="columns"
      :data-source="userDatas"
      class="mb20"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'action'">
          <a-button type="link" size="small" @click="showModal(record.id)"
            >关联角色</a-button
          >
        </template>
      </template>
    </a-table>
    <Pagination></Pagination>
    <a-modal
      v-if="isShow"
      v-model:open="isShow"
      title="关联角色"
      @ok="assignSubmit"
      @cancel="isShow = false"
    >
      <a-checkbox-group v-model:value="roleIds">
        <a-checkbox
          :value="item.id"
          v-for="item in checkboxDatas"
          :key="item.id"
          >{{ item.roleName }}</a-checkbox
        >
      </a-checkbox-group>
    </a-modal>
  </div>
</template>
<script>
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  inject,
  watch,
  provide,
  computed
} from 'vue'
import { message } from 'ant-design-vue'
export default {
  setup() {
    const APIS = inject('APIS')
    const userState = reactive({
      userDatas: [],
      roleList: [],
      isBatch: false,
      params: {
        userName: '',
        departName: ''
      },
      pageNum: 1,
      pageSize: 50,
      total: 0,
      isShow: false,
      roleIds: [],
      userIds: [],
      columns: [
        {
          title: '用户ID',
          dataIndex: 'id',
          key: 'id',
          width: 80
        },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name'
        },
        // {
        //   title: '部门',
        //   dataIndex: 'department',
        //   key: 'department'
        // },
        {
          title: '操作',
          key: 'action'
        }
      ],
      changePage: (pageNum, pageSize) => {
        userState.pageNum = pageNum
        userState.pageSize = pageSize
        getUserList()
      },
      onShowSizeChange: (pageNum, pageSize) => {
        userState.pageNum = 1
        userState.pageSize = pageSize
        getUserList()
      }
    })
    provide('state', userState)
    const { getUserList } = APIS.v1_portal_departmentsByName_post_(userState)
    const { getRoleListByID } = APIS.v1_portal_role_byUserId_post_(userState)
    const { getRoleList, roleDatas } = APIS.v1_portal_role_list_post_()
    const showModal = id => {
      if (id) {
        userState.userId = id
        getRoleListByID(id)
        // APIS.v1_portal_getPermissions_post_({
        //   userId: id
        // })
      }

      userState.isShow = true
    }
    // 批量分配
    const batchAssign = () => {
      if (userState.userIds.length === 0) {
        message.warning('请优先勾选一条记录')
        return false
      }
      userState.isShow = true
      userState.roleIds = []
      userState.isBatch = true
    }
    const setUserIds = userIds => {
      userState.userIds = userIds
    }
    const closeModal = () => {
      userState.isShow = false
    }
    const reset = () => {
      userState.pageNum = 1
      userState.pageSize = 50
      getUserList()
    }
    const assignSubmit = () => {
      const { userIds, roleIds, userId } = userState
      if (userState.isBatch) {
        APIS.v1_portal_user_batchRole_post_(
          {
            userIds,
            roleIds
          },
          () => {
            closeModal()
            userState.userIds = []
          }
        )
      } else {
        APIS.v1_portal_user_assignRole_post_(
          {
            userId,
            roleIds
          },
          closeModal
        )
      }
    }
    const checkboxDatas = computed(() => {
      return userState.isBatch ? roleDatas.value : userState.roleList
    })
    watch(
      () => userState.roleList,
      data => {
        userState.roleIds = []
        data &&
          data.map(_ => {
            if (_.selected) {
              userState.roleIds.push(_.id)
            }
          })
      },
      {
        deep: true
      }
    )
    onMounted(() => {
      getUserList()
      getRoleList()
    })
    return {
      showModal,
      checkboxDatas,
      batchAssign,
      assignSubmit,
      reset,
      setUserIds,
      ...toRefs(userState)
    }
  }
}
</script>
<style lang="scss"></style>
